const isCategory = (categoryId: number) => {
  const params = new URLSearchParams(window.location.search);
  const category = params.get('category');
  const subCategory = params.get('sub_category');
  const productCategory = params.get('product_category');
  const categoryPrefix = `0.${categoryId}`;
  const subCategorySegment = `.${categoryId}.`;

  return Boolean(
    category?.startsWith(categoryPrefix) ??
      subCategory?.includes(subCategorySegment) ??
      productCategory?.includes(subCategorySegment)
  );
};

export const isArtAndAntiquesCategory = () => {
  return isCategory(76);
};

export const isElectronicsCategory = () => {
  return isCategory(93);
};

export const isFurnitureCategory = () => {
  return isCategory(78);
};

export const hasSearchQuery = () => {
  const params = new URLSearchParams(window.location.search);

  const query = params.get('q');

  return query !== null;
};
